import React from "react";
import { Card } from "antd";
import { PieChart } from "@mui/x-charts/PieChart";
import { useTranslation } from "react-i18next";

const AssetsCard = ({ assetsData }) => {
  const total = assetsData.reduce((sum, item) => sum + item.value, 0);
  const { t } = useTranslation();
  const pieChartData = assetsData.map((item, index) => ({
    id: index,
    value: item.value,
    label: t(item.label),
    color: item.color,
  }));

  const valueFormatter = (item) => {
    if (!item || !item.value || total === 0) return "0% (0)";
    const percentage = ((item.value / total) * 100).toFixed(1);
    return `${percentage}% (${item.value.toLocaleString()})`;
  };

  return (
    <Card
      className="col-span-12 md:col-span-6"
      title={t("Assets")}
      extra={
        <div className="text-right">
          <span className="text-lg font-bold text-gray-900">
            {t("Total")}: EGP{" "}
          </span>
          <span className="text-lg font-bold text-gray-900">
            {total.toLocaleString()}
          </span>
        </div>
      }
      style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)", borderRadius: "16px" }}
    >
      <div className="md:hidden flex flex-col md:flex-row items-center gap-4 h-[600px] md:h-[300px] overflow-hidden">
        {/* Pie Chart */}
        <div className="flex-1 md:h-auto md:overflow-visible md:mt-0  h-[270px] overflow-hidden  ml-16 -mb-44">
          <PieChart
            series={[
              {
                data: pieChartData,
                innerRadius: 50,
                arcLabel: () => "",
                valueFormatter,
              },
            ]}
            slotProps={{
              legend: { hidden: true },
              pieArcLabel: {
                style: {
                  fontSize: window.innerWidth < 768 ? 28 : 12,
                  fontWeight: 600,
                  fill: "#fff",
                },
              },
            }}
            width={window.innerWidth < 768 ? 300 : 200}
            height={window.innerWidth < 768 ? 310 : 210}
            margin={{ left: window.innerWidth < 768 ? 20 : -120, top:window.innerWidth < 768 && -120 }}
          />
        </div>

        {/* Scrollable Custom Legend Section */}
        <div className="flex-1 overflow-y-auto h-full asset-legend-scroll space-y-3 md:pe-2  md:-ms-52 scrollbar-thin">
          {assetsData.map((item) => (
            <div
              key={item.id}
              className="flex items-center justify-between py-3 px-3 rounded-lg"
              style={{ backgroundColor: item.bg_color }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-3 h-3 rounded-full flex-shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <span className="text-xs  font-semibold text-gray-700">
                  {t(item.label)}
                </span>
              </div>
              <span className="text-xs font-bold text-gray-900">
                EGP {item.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="hidden md:flex flex-col md:flex-row items-center gap-4 h-[600px] md:h-[300px] overflow-hidden">
        {/* Pie Chart */}
        {/* <div className="flex-1 md:h-auto md:overflow-visible md:mt-0  h-[270px] overflow-hidden -mt-16 ml-16"> */}
          <PieChart
            series={[
              {
                data: pieChartData,
                innerRadius: 50,
                arcLabel: () => "",
                valueFormatter,
              },
            ]}
            slotProps={{
              legend: { hidden: true },
              pieArcLabel: {
                style: {
                  fontSize: window.innerWidth < 768 ? 28 : 12,
                  fontWeight: 600,
                  fill: "#fff",
                },
              },
            }}
            width={window.innerWidth < 768 ? 300 : 200}
            height={window.innerWidth < 768 ? 310 : 210}
            margin={{ left: window.innerWidth < 768 ? 20 : -120, top:window.innerWidth < 768 && -120 }}
          />
        {/* </div> */}

        {/* Scrollable Custom Legend Section */}
        <div className="flex-1 overflow-y-auto h-full asset-legend-scroll space-y-3 md:pe-2 md:-ms-52 scrollbar-thin">
          {assetsData.map((item) => (
            <div
              key={item.id}
              className="flex items-center justify-between py-3 px-3 rounded-lg"
              style={{ backgroundColor: item.bg_color }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-3 h-3 rounded-full flex-shrink-0"
                  style={{ backgroundColor: item.color }}
                />
                <span className="text-xs  font-semibold text-gray-700">
                  {t(item.label)}
                </span>
              </div>
              <span className="text-xs font-bold text-gray-900">
                EGP {item.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>

    </Card>
  );
};

export default AssetsCard;
